import React, {useState} from "react";
import "./Navbar.css";
import {Link} from "react-router-dom";
import {BsFillMoonStarsFill} from "react-icons/bs";
import {MdOutlineLightMode} from "react-icons/md";

function Navbar(props) {
    return (
        <nav style={{backgroundColor: props.darkMode?"rgb(17 24 39)":"darkcyan"}} class="navbar navbar-expand-lg navbar-dark main-nav">
            <div class="container-fluid">
                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div style={{width: "20vw",display: "flex",justifyContent: "center"}}>
                        <div style={{color: "white",fontWeight: "bolder",marginBottom: "0px",fontSize: "28px"}}>GS</div>
                    </div>
                    <div class="navbar-nav" style={{width: "60vw"}}>
                        <div class="nav-item" onClick={()=>{props.setSelected("h"); props.HomeScroll()}}>
                            <a class={props.selected==="h"?"nav-link active highlight":"nav-link active"} aria-current="page" >
                                Home
                            </a>
                        </div>
                        <div class="nav-item" onClick={()=>{props.setSelected("a"); props.AboutMeScroll()}}>
                            <a class={props.selected==="a"?"nav-link active highlight":"nav-link active"}>
                                About
                            </a>
                        </div>
                        <div class="nav-item" onClick={()=>{props.setSelected("p"); props.ProjectsScroll()}}>
                            <Link to="#projects" style={{textDecoration: "none"}}>
                                <a class={props.selected==="p"?"nav-link active highlight":"nav-link active"}>
                                    Projects
                                </a>
                            </Link>
                        </div>
                        <div class="nav-item" onClick={()=>{props.setSelected("c"); props.ContactScroll()}}>
                            <Link to="#blog" style={{textDecoration: "none"}}>
                                <a class={props.selected==="c"?"nav-link active highlight":"nav-link active"}>Contact</a>
                            </Link>
                        </div>
                    </div>

                    <div style={{width: "20vw",display: "flex",justifyContent: "center",marginTop: "-10px",cursor: "pointer"}}>
                        {props.darkMode ?
                            <BsFillMoonStarsFill
                                onClick={() => props.setDarkMode(!props.darkMode)}
                                className=" cursor-pointer text-2xl"
                                style={{color: "white",fontSize: "1.7rem"}}
                            />
                            : <MdOutlineLightMode
                                onClick={() => props.setDarkMode(!props.darkMode)}
                                className=" cursor-pointer text-2xl"
                                style={{color: "black",fontSize: "2rem"}}
                            />
                        }
                    </div>

                </div>
            </div>
        </nav>
    );
}

export default Navbar;
